<script>
	// From Lucide
	import { ArrowUpDown } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ArrowUpDown class={iconClass} />
